module.exports = __webpack_public_path__ + "static/Belmont2022-5038b02720e914c0c534f0b30366cc55.jpg";